<template>
  <div class="noticeLook">
    <el-dialog v-dialogDrag :title="dialogLookTitle" :visible.sync="isShow" :close-on-click-modal="false"
      :close-on-press-escape="false" width="924px" class="noticeEditialog">
      <p class="noticeTitle">{{ tableRow.noticeTitle }}</p>
      <p v-if="dialogLookTitle=='查看'" class="createTime">
        <span style="margin-right:25px">{{ tableRow.createTime }}</span>
        <span>{{ tableRow.operateUserName }}</span>
      </p>
      <p class="noticeAbstract">{{ tableRow.noticeAbstract }}</p>
      <p class="noticeCon" v-html="tableRow.content"></p>
      <!-- 文件 -->
      <div v-if="tableRow.files&&tableRow.files.length&&dialogLookTitle=='查看'" class="enclosure">
        <span>附件:</span>
        <el-table :data="tableRow.files" :show-header="false" max-height="200px" @row-click="rowClick">
          <el-table-column label="名称" prop="fileName"></el-table-column>
          <el-table-column label="操作" fixed="right" width="120px">
            <template slot-scope="scope">
              <span class="midd-table">
                <i class="el-icon-download" title="下载" @click.stop="uploadRowType(scope.$index, tableRow.files)" />
              </span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div v-if="tableRow.isOpen===0" class="person" :title="tableRow.userNames">
        <span> 可见人: </span>
        <span style="margin-left:5px">{{ tableRow.userNames }}</span>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="isShow=false">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { filePreviewV1 } from "@/CommonDP/utils/docPublic";
import { downloadUrltoken } from "@/CommonDP/mongeView/utils";
import { mapState } from "vuex";
export default {
  props: {
    dialogLookTitle: {
      type: String,
      required: true,
      default: "查看"
    },
    announdialogLookVisible: {
      type: Boolean,
      required: true,
      default: false
    },
    tableRow: {
      type: Object,
      required: true,
      default: () => {}
    },
    close: {
      type: Function,
      required: true,
      default: () => {}
    },
    name: {
      type: String,
      required: true,
      default: () => ""
    }
  },
  data() {
    return {};
  },
  computed: {
    ...mapState({
      prjInfo: (state) => state.projectMg.prjObj
    }),
    isShow: {
      set() {
        this.close();
      },
      get() {
        return this.announdialogLookVisible;
      }
    }
  },
  created() {},
  methods: {
    rowClick(row) {
      var row1 = {
        fileId: row.fileId,
        versionId: row.fileVersion || 1,
        fileType: Number(row.fileType),
        status: row.status
      };
      filePreviewV1(row1, this.tableRow.files);
    },
    uploadRowType(index, row) {
      const prjId = this.name === "prj" ? this.prjInfo.prjId : "EnterpriseDoc";
      const fileId = row[index].fileId;
      window.location = downloadUrltoken(prjId, fileId);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../styles/noticeEditialog.css";
.noticeEditialog {
  /deep/ .el-dialog {
    min-width: 420px;
    .el-dialog__body {
      padding: 18px !important;
      .noticeTitle {
        text-align: center;
        font-size: 20px;
        color: var(--key-color);
      }
      .createTime {
        text-align: center;
        margin-top: 9px;
        span {
          color: #acb5c9;
          font-size: 16px;
        }
      }
      .noticeAbstract {
        color: var(--key-color);
        font-size: 18px;
        margin-top: 16px;
      }
      .noticeCon {
        margin-top: 16px;

        p {
          font-size: 14px !important;
        }
      }
      .person {
        padding: 10px 0;
        span {
          font-size: 14px;
        }
      }
      .enclosure {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin-top: 20px;
        span {
          margin-right: 10px;
          color: var(--key-color);
          font-size: 18px;
        }

        .cell {
          font-size: 16px !important;
        }
      }
    }
    .el-dialog__footer {
      text-align: center;
    }
  }
}
</style>
